<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> PUBLICAÇÃO DE RELATÓRIOS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="success" v-if="successSave">
        <template v-slot:close>
          <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
        </template>
        Publicação de Relatório com Sucesso
      </v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1" xs="12" md="2">
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="months"
                width="100px"
                dense
                hide-default-footer
                item-key="value"
                show-select
                class="elevation-1"
              >
              </v-data-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn dark color="blue darken-3" small class="mt-1">
                Atualizar Informações
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
// import { URL } from "@/api/config";
export default {
  components: {},
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    headers: [
      {
        text: "Mês",
        align: "start",
        sortable: false,
        value: "text",
      },
    ],
    selected: [],
    month: "",
    years: [],
    year: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {},
    validate() {},
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
</style>
